import React from 'react';
export function ResultsGallery() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1611171711912-e0e5b7f0e9b3?w=400&h=400&fit=crop',
    alt: 'Amigurumi tejido'
  }, {
    url: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&h=400&fit=crop',
    alt: 'Flores de crochet'
  }, {
    url: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=400&h=400&fit=crop',
    alt: 'Muñecos tejidos'
  }, {
    url: 'https://images.unsplash.com/photo-1611171711912-e0e5b7f0e9b3?w=400&h=400&fit=crop',
    alt: 'Patrones de crochet'
  }, {
    url: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400&h=400&fit=crop',
    alt: 'Accesorios tejidos'
  }, {
    url: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=400&h=400&fit=crop',
    alt: 'Decoraciones navideñas'
  }];
  return <section className="w-full py-16 px-4 bg-white" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-108">
          Mirá todo lo que vas a poder crear
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-109">
          {images.map((image, index) => <div key={index} className="aspect-square rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow" data-id="element-110">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover" data-id="element-111" />
            </div>)}
        </div>
      </div>
    </section>;
}